import { mapEnumToOptions } from '@abp/ng.core';

export enum TicketKind {
  Renewal = 0,
  Education = 1,
  DocumentApproval = 2,
  Ticket = 3,
  Test = 4,
}

export const ticketKindOptions = mapEnumToOptions(TicketKind);
